import { objectSpread2 as _objectSpread2 } from "./_virtual/_rollupPluginBabelHelpers.js";
function getConfig(cfg) {
  return _objectSpread2({
    vid: "",
    moovEnd: 8e4,
    segmentDuration: 2,
    maxDownloadInfoSize: 30,
    responseType: "arraybuffer",
    cache: null
  }, cfg);
}
export { getConfig };
